import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import Logo from 'src/components/logo';

// ----------------------------------------------------------------------

export default function CompactLayout({ children }) {
  return (
    <Container component="main">
      <Stack
        gap={2}
        sx={{
          py: 12,
          m: 'auto',
          maxWidth: 400,
          minHeight: '100vh',
          textAlign: 'center',
          justifyContent: 'center',
        }}
      >
        <div>
          <Logo sx={{ width: 150 }} />
        </div>
        {children}
      </Stack>
    </Container>
  );
}

CompactLayout.propTypes = {
  children: PropTypes.node,
};
